import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-chooseselected",
  "use": "icon-chooseselected-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-chooseselected\">\n    <!-- Generator: Sketch 53.2 (72643) - https://sketchapp.com -->\n    <title>icon24/chooseselected</title>\n    <desc>Created with Sketch.</desc>\n    <g id=\"icon-chooseselected_icon24-symbols\" stroke=\"none\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\">\n        <g id=\"icon-chooseselected_icon24/chooseselected\">\n            <rect id=\"icon-chooseselected_Rectangle\" fill=\"#DCFFE4\" x=\"3\" y=\"3\" width=\"18\" height=\"18\" rx=\"3\" />\n            <rect id=\"icon-chooseselected_Rectangle\" fill=\"#18D2A3\" x=\"5\" y=\"5\" width=\"14\" height=\"14\" rx=\"1\" />\n        </g>\n    </g>\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/chooseselected.svg
// module id = pef3
// module chunks = 54